<template>
    <div
        :class="{
            '-focus': bodyOpened,
            '-disabled': section.disabled || disabled
        }"
        class="section-selector"
    >
        <div
            @click="bodyOpened = false"
            class="filter-click-area"
            v-if="bodyOpened"
        ></div>
        <div @click="toggleBody" class="selector-container" ref="container">
            <transition mode="out-in" name="fade">
                <transition-group
                    mode="out-in"
                    name="list"
                    style="display: flex;"
                    tag="div"
                    v-if="!loading && selectedValues.length != 0"
                >
                    <div
                        :key="value.value"
                        class="display-element"
                        v-for="value in selectedValues"
                    >
                        <Emoji
                            :value="value.icon"
                            class="input-icon"
                            v-if="value.icon"
                        />
                        {{ value.display }}
                    </div>
                </transition-group>
                <div
                    :key="'placeholder'"
                    class="display-element"
                    v-if="!loading && selectedValues.length == 0"
                >
                    {{ $t('LABEL_EMPTY_COMMENT') }}
                </div>
            </transition>
        </div>
        <transition name="fade">
            <div
                :style="{ marginTop: bodyY }"
                class="selector-body"
                ref="body"
                v-if="bodyOpened"
            >
                <div class="options-search">
                    <input
                        type="search"
                        v-model="search"
                        v-if="section.search"
                    />
                </div>
                <ListPlaceholder
                    v-if="filteredOptions.length == 0"
                    :title="$t('LABEL_LIST_IS_EMPTY')"
                ></ListPlaceholder>
                <div class="body-rows">
                    <div
                        :key="index"
                        class="body-row"
                        v-for="(option, index) in filteredOptions"
                    >
                        <div class="row-display">
                            <Emoji
                                :value="option.icon"
                                class="input-icon"
                                v-if="option.icon"
                            />
                            {{ option.display }}
                        </div>
                        <CheckBox
                            color="apple"
                            @input="selectOption(option)"
                            v-model="option.selected"
                        ></CheckBox>
                    </div>
                </div>
                <div
                    @click="addItem(section)"
                    class="body-row -add"
                    v-if="adding"
                >
                    <div class="row-display">
                        <div class="list-action-icon">
                            <i class="material-icons">{{ 'add' }}</i>
                        </div>
                        {{ $t('BUTTON_ADD') }}
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>
<script>
export default {
    props: {
        value: [Array, Number],
        options: Array,
        placeholder: String,
        propLoading: Boolean,
        adding: Boolean,
        section: Object,
        popup: Boolean,
        disabled: Boolean
    },
    data() {
        return {
            bodyOpened: false,
            selectedValues: [],
            bodyY: '',
            loading: true,
            search: ''
        }
    },
    computed: {
        filteredOptions() {
            return this.options.filter(o => {
                const r = new RegExp(`\\w?${this.search}\\w?`, 'i')
                return r.test(o.display) || (r.test(o.value) && !o.hidden)
            })
        }
    },
    methods: {
        addItem(section) {
            this.$emit('addItem', section)
            this.bodyOpened = false
        },
        selectOption(option) {
            if (option.value == 'reset') {
                return this.$emit('input', ['reset'])
            }
            let value = this.options
                .map(option => {
                    if (option.selected) {
                        return option.value
                    }
                })
                .filter(option => option)
            const resetIndex = value.findIndex(v => v == 'reset')
            if (resetIndex != -1) {
                value.splice(resetIndex, 1)
            }
            this.$emit('input', value)
        },
        toggleBody($event) {
            if (this.section.disabled || this.disabled) {
                return
            }
            this.$emit('click')
            if (this.bodyOpened) {
                this.bodyOpened = false
                return
            }
            this.bodyOpened = !this.bodyOpened
            let className = this.popup ? 'popup-slot' : 'router-view-content'
            this.$nextTick(() => {
                let largestHeight =
                    window.innerHeight - this.$refs.body.offsetHeight - 50
                const path = this.$Utils.getElementPath($event)
                let index = path.findIndex(item => {
                    return item.className == className
                })
                let scrollOffset = 0
                if (path[index]) {
                    scrollOffset = path[index].scrollTop
                }
                if (largestHeight < $event.clientY) {
                    this.bodyY = this.popup
                        ? `calc(${-scrollOffset -
                              this.$refs.body.offsetHeight}px - 2.3rem)`
                        : `calc(${-this.$refs.body.offsetHeight +
                              scrollOffset}px - 2.3rem)`
                } else {
                    this.bodyY = `-${scrollOffset}px`
                }
            })
        }
    },
    mounted() {
        this.loading = this.propLoading
        this.options.forEach(option => {
            if (this.value != -1 && this.value.some(v => v == option.value)) {
                option.selected = true
            } else {
                option.selected = false
            }
        })
        this.selectedValues = this.options
            .filter(option => option.selected == true)
            .map(option => {
                return {
                    display: option.display,
                    icon: option.icon,
                    value: option.value
                }
            })
        if (!this.propLoading) {
            this.loading = this.propLoading
        }
    },
    watch: {
        value() {
            this.options.forEach(option => {
                if (this.value.some(v => v == option.value)) {
                    option.selected = true
                } else {
                    option.selected = false
                }
            })
            this.selectedValues = this.options
                .filter(option => option.selected == true)
                .map(option => {
                    return {
                        display: option.display,
                        icon: option.icon,
                        value: option.value
                    }
                })
            this.loading = this.propLoading
        }
    }
}
</script>
<style lang="scss" scoped>
.options-search {
    input {
        background: #fff;
        color: $input;
        width: 100%;
        border-radius: 0;
    }
}
.list-selector {
    position: relative;
    width: 100%;
    max-width: 60vw;

    &.-error {
        color: $accent-red !important;
    }
}
.filter-click-area {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: $highest;
}
.selector-body {
    position: fixed;
    background: $background;
    z-index: $highest;
    max-height: 30vh;
    max-width: 30vw;
    overflow: hidden;
    overflow-y: auto;
    margin-left: -0.1rem;
    border: 0.1rem solid $border-accent;
    border-radius: $minimal-radius;
    display: flex;
    flex-direction: column;
    color: var(--color) !important;
}
.body-rows {
    max-height: 100%;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    overflow: hidden;
}
.body-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.5rem 0.7rem;
    user-select: none;
    transition: $ease;
    text-overflow: ellipsis;
    white-space: nowrap;

    &.-add {
        color: $action-accent;
        border-top: 0.1rem solid $border-accent;
        cursor: pointer;
        font-family: $input-family;
        &:hover {
            background: darken($background, 2%);
        }
    }
}
.row-display {
    margin-right: 1rem;
}
.display-element {
    margin-right: 1rem;
    display: flex;
    align-items: center;
    transition: $ease;
    white-space: nowrap;
    overflow: hidden;
}
.list-enter-active,
.list-leave-active {
    transition: all 1s;
}
.list-enter,
.list-leave-to {
    opacity: 0;
    transform: translateY(30px);
}
</style>
